import * as React from "react";
import {FC} from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {useTheme} from "@mui/material/styles";
import {WishType} from "../../../store/wish/Helper";

interface IProps {
    cost: number
    originalCost: number | null
    type: WishType
}

const DiscountRibbon: FC<IProps> = (props) => {
    const theme = useTheme()
    if (props.type === WishType.BUNDLE) {
        return null
    }

    return (
        props.originalCost && props.originalCost > props.cost ? (
            <Box
                sx={{
                    position: "absolute",
                    top: -95,
                    left: -88,
                    width: 150,
                    height: 150,
                    transform: "rotate(45deg)",
                    overflow: "hidden",
                    zIndex: 2,
                    pointerEvents: "none",
                    backgroundColor: theme.palette.tertiary.main,
                    boxShadow: "0 6px 10px rgba(0,0,0,0.3)"
                }}
            >
                <Typography
                    variant="subtitle2"
                    sx={{
                        position: "absolute",
                        top: 70,
                        left: 112,
                        transform: "rotate(270deg)",
                        fontWeight: 700,
                        color: theme.palette.tertiary.contrastText,
                    }}
                >
                    -{Math.floor(((props.originalCost - props.cost) / props.originalCost) * 100)}&nbsp;%
                </Typography>
            </Box>
        ) : null
    )
}

export default DiscountRibbon;
